"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { AlertCircle } from "lucide-react"
import { getFeedFromURL } from "@/lib/api/import"
import { InputDescription } from "../../../components/InputRow/InputDescription"
import { FeedData as Feed } from "@extractus/feed-extractor"
import { ImportType } from "../../types"

interface ImportURLInputProps {
  url: string
  setUrl: (url: string) => void
  setFeed: (feed: Feed | null) => void
  setImportType: (type: ImportType) => void
}

export function ImportURLInput({
  url,
  setUrl,
  setFeed,
  setImportType,
}: ImportURLInputProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!url) return

    setError(null)
    setIsLoading(true)

    if (url.includes("mirror.xyz")) {
      setImportType("MIRROR")
    } else {
      const feed = await getFeedFromURL(url)
      if (!feed) {
        setError("Unable to parse feed. Are you using the correct URL?")
        setIsLoading(false)
        return
      }
      setFeed(feed)
      setImportType("RSS")
    }

    setIsLoading(false)
  }

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <InputDescription>Import from</InputDescription>
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.yourblog.com/rss"
          className="max-w-[400px]"
        />
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <Button
        type="submit"
        disabled={!url || isLoading}
        className="max-w-[200px]"
      >
        {isLoading ? "Loading..." : "Next"}
      </Button>
    </form>
  )
}
